import './answerOption.css'
import parse from 'html-react-parser';
const AnswerOption = (props)=>{
    const {isAnswer, on, oc, wrong,ar} = props
    console.log(isAnswer, on, oc, wrong,ar);
    return(
        <label className={(ar == on && isAnswer && !wrong) ?'que_opt answer option':(ar == on && wrong)?'que_opt wrong option':'option'}>
            <input type="radio" name="question" value={on} />
            <span className="option-text"><strong className="circle">{on}</strong>{parse(oc)} </span>
            {isAnswer && !wrong? (
                <span className="ans-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 35 35" fill="none">
                        <g clip-path="url(#clip0_772_1169)">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M17.5 0C7.84766 0 0 7.84766 0 17.5C0 27.1523 7.84766 35 17.5 35C27.1523 35 35 27.1523 35 17.5C35 7.84766 27.1523 0 17.5 0Z" fill="#4BAE4F"/>
                            <path d="M14.1299 25.5049C11.8945 23.2695 9.67285 21.0137 7.43066 18.7783C7.18457 18.5322 7.18457 18.1221 7.43066 17.876L10.0078 15.2988C10.2539 15.0527 10.6641 15.0527 10.9102 15.2988L14.5947 18.9834L24.0693 9.50195C24.3223 9.25586 24.7256 9.25586 24.9785 9.50195L27.5625 12.0859C27.8154 12.3389 27.8154 12.7422 27.5625 12.9883L15.0322 25.5049C14.7861 25.7578 14.3828 25.7578 14.1299 25.5049Z" fill="white"/>
                        </g>
                        <defs>
                            <clipPath id="clip0_772_1169">
                            <rect width="35" height="35" fill="white"/>
                            </clipPath>
                        </defs>
                    </svg>
                </span>):wrong? (
                    <span className="ans-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 35 35" fill="none">
                        <g clip-path="url(#clip0_772_1162)">
                            <path d="M17.5 35C27.165 35 35 27.165 35 17.5C35 7.83502 27.165 0 17.5 0C7.83502 0 0 7.83502 0 17.5C0 27.165 7.83502 35 17.5 35Z" fill="#FF5023"/>
                            <path d="M27.7539 10.7276L24.2724 7.24609L17.5 14.0185L10.7276 7.24609L7.24609 10.7276L14.0185 17.5L7.24609 24.2724L10.7276 27.7539L17.5 20.9815L24.2724 27.7539L27.7539 24.2724L20.9815 17.5L27.7539 10.7276Z" fill="#FFF5F5"/>
                        </g>
                        <defs>
                            <clipPath id="clip0_772_1162">
                            <rect width="35" height="35" fill="white"/>
                            </clipPath>
                        </defs>
                    </svg>
                </span>
                ):""
                }
        </label>
        /* <div className={isAnswer && !wrong?'answer_option answer':(wrong? 'answer_option wrong':'answer_option')}>
        <div className='option_num'><div style={{alignSelf: 'center'}}>{on}</div></div>
        <div className='option_content'>{parse(oc)}</div>
        </div> */
    )
}
export default AnswerOption